import { render, staticRenderFns } from "./AnnotationHistoryModal.vue?vue&type=template&id=6c25701a&scoped=true&"
import script from "./AnnotationHistoryModal.vue?vue&type=script&lang=js&"
export * from "./AnnotationHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25701a",
  null
  
)

export default component.exports